import { Subject } from 'rxjs';
import { tap, takeUntil } from 'rxjs/operators';

import { Location } from '@angular/common';
import {
  OnInit,
  OnDestroy,
  Component,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from '@angular/core';

import { SnRouterHelperService, mapToRouteDataItem } from '@lib/state/router';

import { SnLayoutNavbarContainer } from '../../containers';
import { SnLayoutService } from '../../services';

@Component({
  selector: 'sn-layout-appbar-nav-button',
  templateUrl: './layout-appbar-nav-button.component.html',
  styleUrls: ['./layout-appbar-nav-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnLayoutAppbarNavButtonComponent implements OnInit, OnDestroy {
  public isRootRoute = true;
  public canNavigationBack = false;

  private readonly _destroy$ = new Subject<void>();

  constructor(
    private readonly _location: Location,
    private readonly _routerHelper: SnRouterHelperService,
    private readonly _layoutService: SnLayoutService,
    private readonly _changeDetectorRef: ChangeDetectorRef,
  ) {}

  get navbar(): SnLayoutNavbarContainer {
    return this._layoutService.navbar;
  }

  public ngOnInit(): void {
    this._routeChangeSubscribe();
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  private _routeChangeSubscribe(): void {
    this._routerHelper.routeChange$
      .pipe(
        tap(() => {
          const locationState: any = this._location.getState();
          this.canNavigationBack = locationState && locationState.navigationId > 1;
          this._changeDetectorRef.detectChanges();
        }),
        mapToRouteDataItem('snRoute'),
        takeUntil(this._destroy$),
      )
      .subscribe((data) => {
        this.isRootRoute = data && !!data.root;
        this._changeDetectorRef.detectChanges();
      });
  }
}
